import { mapState } from 'vuex'
import FormFieldException from '~/utils/exceptions/FormFieldException'
import STATES_CODE_DATA from '~/constants/statesCodeData'

export default {
  data () {
    return {
      error: ''
    }
  },
  computed: {
    ...mapState('user', ['accountCreated']),
    formFields () {
      return Object.keys(this.fields)
    }
  },
  methods: {
    getFormFieldParam (field, param) {
      return this.fields[field][param]
    },
    getStateCode (zipCode) {
      const hasLessFiveChar = zipCode.length !== 5
      const zipCodeNumber = hasLessFiveChar
        ? parseInt(zipCode.substring(0, 5), 10)
        : parseInt(zipCode, 10)

      let stateCode = 'none'

      const matchingZipCodeNumberData = STATES_CODE_DATA.find((stateCodeData) => {
        const { zipCodeBetween } = stateCodeData
        const lowestZipCodeNumber = zipCodeBetween[0]
        const biggestZipCodeNumber = zipCodeBetween[1]
        return zipCodeNumber >= lowestZipCodeNumber && zipCodeNumber <= biggestZipCodeNumber
      })

      if (matchingZipCodeNumberData) {
        stateCode = matchingZipCodeNumberData.stateCode
      }
      return stateCode
    },
    validateZipCode () {
      const zipCode = this.getFormFieldParam('zipCode', 'value')
      const isValidZipCode = zipCode !== 'none'
      if (isValidZipCode) {
        return true
      } else {
        const error = this.$t('general.collectionChoice.errors.invalidZipCode')
        throw new FormFieldException(error, 'zipCode')
      }
    },
    markFieldAsError (field) {
      this.fields[field].isValid = false
    },
    clearErrors () {
      this.error = ''
      Object.keys(this.fields).forEach((field) => {
        this.fields[field].isValid = null
      })
    }
  }
}
